import axios from "axios";

/**
 * 뉴스 URL 파싱 후 데이터 가져오기
 * @param {string} url - 뉴스 URL
 * @param {string} id - 유저 ID (선택적)
 * @param {function} setNewsData - 뉴스 데이터 상태 업데이트 함수
 * @param {function} setLoading - 로딩 상태 업데이트 함수
 * @param {function} [onError] - 에러 발생 시 호출할 선택적 콜백
 */
export const fetchNewsData = async (url, id, setNewsData, setLoading, onError) => {
    if (!url) return;

    setLoading(true);
    try {
        const res = await axios.post(`${process.env.REACT_APP_SPRING_API_URL}/api/parse-news`, {
            url,
            id: id || ""
        });
        setNewsData(res.data);
    } catch (err) {
        console.error("뉴스 파싱 실패:", err);
        setNewsData(null);
        if (onError) onError(err);
    } finally {
        setLoading(false);
    }
};
